import Loadable from 'react-loadable';
import Loading from '../shared/Loading';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "TextareaWithUploader" */ '../../common/uploader/TextareaWithUploader'),
  loading: Loading,
});
